import React, { useState, useEffect } from "react";
import { makeStyles } from '@material-ui/core';
import { getUserFactoryId, getStructureTree } from '../../../index';
import Chart from "react-google-charts";
import { TableContainer, TableBody, TableCell, Table, TableRow, Grid,
    TableHead, Paper, Snackbar, TextField, Typography, IconButton, Collapse,
    Box, Select, MenuItem
} from '@material-ui/core';

import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import api from '../../services/api';
import { Button, FormControl } from 'react-bootstrap'

import HistoryYearModalForm from './HistoryYearModal';
import HistoryMonthlyModalForm from "./HistoryMonthlyModal";

export async function getStructures(factoryId) {

    let response = await api.get(`/structure/odata?$filter=factoryId+eq+${getUserFactoryId()}`);
    console.log(response.data.value)
    if (response.status === 200)
        return response.data.value;
    else
        return [];

}

const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
});

function HeadComponent(props) {

    const { heads } = props;

    return (
        <TableHead>
            <TableRow>
                {heads.map(h => (
                    <TableCell key={h}> {h} </TableCell>
                ))}
            </TableRow>
        </TableHead>
    )
}

function RowComponent(props) {

    const { row, heads } = props;

    const setOpen = (row) => { props.setOpen(row) }
    return (
        <React.Fragment>
            <TableRow>
                {   row.nodes.length > 0 &&
                    <TableCell>
                        <IconButton aria-label="expand row" size="small" onClick={() => setOpen(row)}>
                            {row.open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                        </IconButton>
                    </TableCell>
                }
                

                {row.cells.map((cell, index) => (
                    <TableCell key={index}> 
                        {cell}
                    </TableCell>
                ))}

            </TableRow>

            <MiniTableComponent row={row} heads={heads} setOpen={setOpen} />
        </React.Fragment>
    );
}

function MiniTableComponent(props) {

    const { row, heads } = props;

    const setOpen = (row) => { props.setOpen(row) }

    return (
        <TableRow>
            <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={heads.length}>
                <Collapse in={row.open} timeout="auto" unmountOnExit>
                    <Box margin={1}>
                        <Table size="small" aria-label="purchases">                            
                            <TableBody>
                                {row.nodes.map(node => (
                                    <RowComponent key={node.id} heads={ heads } row={node} setOpen={setOpen} />
                                ))}
                            </TableBody>
                        </Table>
                    </Box>
                </Collapse>
            </TableCell>
        </TableRow>
    );
}

function TableComponent(props) {

    const { heads, rows, classes } = props;

    const setOpen = (row) => { props.setOpen(row) }

    return (
        <TableContainer component={Paper}>
            <Table className={classes.table}>
                <HeadComponent heads={heads} />
                <TableBody>
                    {rows.map(row => (
                        <RowComponent key={row.id} row={row} heads={ heads} setOpen={setOpen} />
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}

export default function IdcardHistoryPage() {

    const classes = useStyles();
               
    const [rows, setRows] = useState([]);
    const [tipoModal, setTipoModal] = useState(0)
    const [count, setCount] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [elementModal, setElementModal] = useState(false);

    const heads = ["", "Estrutura", "Valores"];

    useEffect(() => {
        const init = async () => {
            
            const structureTreeApi = await getStructureTree();  
            const rowsArray = createRows(structureTreeApi.structures);
            setRows(rowsArray);
        }
        init();
    }, []);

    const createRows = (rowsArray) => {
        return rowsArray.map((element, index) => {
            var isOpen = false;
            if (rows.length > 0) {
                const findRow = getChildById(rows[0], element.key)
                isOpen = findRow == null ? false : findRow.open;    
            }

            return (
                {
                    id: element.key,
                    cells:
                        [
                            element.label,
                            valoresButton(element)
                        ],
                    nodes: element.nodes ? createRows(element.nodes) : null,
                    open: isOpen
                });
        })
    }

    const getChildById = (root, id) => {
        if (root.id == id) return root;
        for (var i = 0; i < root.nodes.length; i++) {
            var found = getChildById(root.nodes[i], id);
            if (found) return found;
        }    
    }

    const valoresButton = (element) => {

        return (
            <>
                {/* {
                    element.structureType == "Linha" &&
                    <Button variant="primary" size="sm" style={{ marginRight: '10px' }}
                        onClick={e => {
                            setShowModal(true);
                            setElementModal(element);
                            setTipoModal(1)
                        }
                        }>
                        Configurar Anual
                    </Button>
                } */}
                {
                    element.structureType == "Linha" &&
                    <Button variant="primary" size="sm" style={{ marginRight: '10px' }}
                        onClick={e => {
                            setShowModal(true);
                            setElementModal(element);
                            setTipoModal(2)
                        }
                        }>
                        Configurar Mensal
                    </Button>
                }
            </>
        )
    }

    const setOpen = (row) => {
        row.open = !row.open;
        setCount(count + 1);
        console.log(row)
    }
               
    return (
        <>
            {
                showModal && tipoModal == 1 &&
                <HistoryYearModalForm item={elementModal} showModal={showModal} callback={e => setShowModal(false)} />
                
            }
            {
                showModal && tipoModal == 2 &&
                <HistoryMonthlyModalForm item={elementModal} showModal={showModal} callback={e => setShowModal(false)} />
                
            }         
            <Grid container spacing={2} direction="column">
                <Grid item>
                    <TableComponent rows={rows} heads={heads} classes={classes} setOpen={setOpen} /> 
                </Grid>
            </Grid>
        </>
    );
}